import { useT } from '@hooks';
import React from 'react';
import checkTheme from '../../../../../../src/utils/custom/checkTheme';

import s from './index.module.scss';

function Description() {
	const { T } = useT();
	return (
		<div className={`${s.description} ${s[checkTheme()]}`}>
			<h3 className={s.descriptionTitle}>{T('safe')}</h3>
			<p className={s.descriptionText}>{T('information')}</p>
			<h3 className={s.descriptionTitle}>{T('secure_checkout')}</h3>
			<p className={s.descriptionText}>{T('encrypted')}</p>
			<h3 className={s.descriptionTitle}>{T('help')}</h3>
			<p className={s.descriptionText}>
				{T('contact')}{' '}
				<a
					className={s.descriptionLinkInline}
					href='mailto:support@verv.health'
					target='_blank'
					rel='noreferrer'
				>
					{T('here')}
				</a>
			</p>
			<a
				href='https://verv.com/privacy-policy-main/'
				className={s.descriptionLink}
				target='_blank'
				rel='noreferrer'
			>
				{T('privacy_policy')}
			</a>
			<a
				href='https://verv.com/terms-conditions/'
				className={s.descriptionLink}
				target='_blank'
				rel='noreferrer'
			>
				{T('terms_conditions')}
			</a>
		</div>
	);
}

export default Description;
